import React, { useEffect, useState } from "react";
import { apiPhp } from "../../../utils/Common";
import { Message } from "semantic-ui-react";
import moment from "moment";

const TablaCosecha = (props) => {
  const { uuid, plan } = props;
  console.log(uuid, plan);

  const [cosecha, setCosecha] = useState([]);

  useEffect(() => {
    apiPhp
      .get("get_cosecha_ingresada", {
        params: {
          uuid,
          plan,
        },
      })
      .then((r) => {
        console.log(r.data);
        setCosecha([...r.data.cosecha]);
      });
  }, [uuid, plan]);

  return (
    <React.Fragment>
      {cosecha.length > 0 ? (
        <table className="ui small table">
          <thead>
            <tr style={{ textAlign: 'center' }}>
              <th>Fecha</th>
              <th>Cantidad (tallos)</th>
              <th>Estatus</th>
            </tr>
          </thead>
          <tbody>
            {
              cosecha.map(( c, i ) => {
                return (
                  <tr key={ i }>
                    <td style={{ textAlign: 'center' }}>{ moment(c.created_at).format( 'DD-MMMM/YYYY' ) }</td>
                    <td style={{ textAlign: 'right' }}>{ c.cantidad_tallos }</td>
                    <td style={{ textAlign: 'center' }}>{ c.estatus }</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      ) : (
        <Message negative>
          <Message.Header>Sin Datos</Message.Header>
          <p>No se tienen cosechas registradas en el plan: {plan}</p>
        </Message>
      )}
    </React.Fragment>
  );
};

export default TablaCosecha;
